import React, {
  useState,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { formatSeconds } from '@playbookux/playbook-web-core';

import {
  Accordion,
  Icon,
  IconContainer,
  ImageVideoQuestionLabel,
  TaskLabel,
  TaskNumber,
  TaskNumberContainer,
} from './styles';

import range from './range-question';
import url from './url-question';
import task from './task-question';
import written from './written-question';
import selectQuestion from './select-question';

import { mediaQuestions } from '../../../../company/constants/question-types';

const questionTypes = {
  range,
  url,
  task,
  written,
  multiple_select: selectQuestion,
  single_select: selectQuestion,
  image_select: url,
  audio_video: url,
};

const getStartTime = (answer) => {
  if (!answer) {
    return '00:00';
  }

  return (
    <time>
      {formatSeconds(answer.videoStartTime)}
    </time>
  );
};

const getTimeOnTask = (answer) => {
  if (!answer) {
    return '00:00';
  }

  return (
    <time>
      {formatSeconds(answer.videoEndTime - answer.videoStartTime)}
    </time>
  );
};

const Questions = (props) => {
  const {
    question,
    onClick,
    index,
    answer,
    onSubmit,
    onCurrentTime,
    onRemoveTagHighlight,
  } = props;

  const [active, setActive] = useState(true);

  const handleClickQuestion = useCallback(() => {
    if (typeof onClick === 'function') onClick();
    setActive(!active);
  }, [active, setActive, onClick]);

  const handleCurrentTime = () => {
    onCurrentTime(answer.videoStartTime);
  };

  const QuestionLayout = questionTypes[question.questionType];
  const isMediaQuestion = mediaQuestions.includes(question.questionType);
  let { label } = question;

  if (isMediaQuestion) label = <ImageVideoQuestionLabel href={question.imageUrl || question.videoUrl} />;

  return (
    <>
      <Accordion.Title
        active={active}
        index={index}
        onClick={handleClickQuestion}
        data-transcript-video-start-time={answer.videoStartTime}
        data-transcript-video-end-time={answer.videoEndTime}
      >
        <IconContainer>
          <Icon
            name={active ? 'chevron up' : 'chevron down'}
          />
        </IconContainer>
      </Accordion.Title>

      <TaskNumberContainer>
        Question
        {' '}
        {index + 1}
        &nbsp;
        <TaskNumber onClick={handleCurrentTime}>
          (
          {getStartTime(answer)}
          )
        </TaskNumber>
      </TaskNumberContainer>

      <TaskLabel>
        {label}
      </TaskLabel>

      <QuestionLayout
        question={question}
        startTime={getStartTime(answer)}
        onClick={handleClickQuestion}
        index={index}
        active={active}
        answer={answer}
        timeOnTask={getTimeOnTask(answer)}
        onSubmit={onSubmit}
        onRemoveTagHighlight={onRemoveTagHighlight}
      />
    </>
  );
};

Questions.propTypes = {
  question: PropTypes.shape({
    questionType: PropTypes.string,
    label: PropTypes.string,
    imageUrl: PropTypes.string,
    videoUrl: PropTypes.string,
  }).isRequired,
  answer: PropTypes.shape({
    videoStartTime: PropTypes.string,
    videoEndTime: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  index: PropTypes.number.isRequired,
  onCurrentTime: PropTypes.func.isRequired,
  onRemoveTagHighlight: PropTypes.func.isRequired,
};

Questions.defaultProps = {
  onClick: () => { },
};

export default Questions;
